export default "__VITE_ASSET__DOU6IJlP__"